import gql from 'graphql-tag'

const GET_WITH_PAGINATION = gql`
    query customersWithPagination($page: Int, $perPage: Int) {
        customersWithPagination(page: $page, perPage: $perPage){
            page
            pages
            hasNext
            hasPrev
            total
            objects {
                id
                name
                lastName
                email
                country
                phoneNumber
                documentNumber
                city
                isActive
            }
        }
    }
`
const GET_SUMMARY = gql`
    query {
        customersSummary {
            total
            inactive
            active
        }
    }
`

const GET_BY_ID = gql`
    query customer($customerId: ID) {
        customer(id: $customerId) {
            id
            name
            lastName
            documentNumber
            phoneNumber
            smartphoneNumber
            email
            country
            city
            province
            postalCode
            language
            recommendationCode
            address
            isActive
        }
    }
`

export {
    GET_WITH_PAGINATION,
    GET_SUMMARY,
    GET_BY_ID
}
